import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListOrdenesProv from './ListOrdenesProv';
import OrdenView from './OrdenView';

export default class AdmOrdenesProveedores extends React.Component {
    render() {
        return (
            <div>
                <Routes>
                    <Route path="" element={<ListOrdenesProv />} />
                    <Route path="View/:id" element={<OrdenView />} />
                </Routes>
            </div>
        );
    }
}